export abstract class ErrorShower {
  abstract showFormErrors(): void;
}

export interface IErrorShower {
  showFormErrors(): void;
}
